import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Star } from "@phosphor-icons/react";
import { formatGHS } from "@/lib/format";
import { useCart } from "@/lib/cart";

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group bg-[#141414] border border-white/10 beam-glow flex flex-col"
    >
      <Link to={`/products/${product.slug}`} className="block relative overflow-hidden aspect-[4/3]">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-[#FFC107] text-black text-[10px] font-black uppercase tracking-[0.18em] px-2 py-1">
            {product.badge}
          </span>
        )}
        <span className="absolute top-3 right-3 font-mono-accent text-[10px] tracking-widest uppercase bg-black/70 border border-white/20 px-2 py-1">
          {product.category}
        </span>
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <div className="flex items-center gap-1.5 text-[#FFC107] text-xs mb-2">
          <Star size={14} weight="fill" />
          <span className="font-mono-accent">{product.rating?.toFixed(1)}</span>
          <span className="text-zinc-500">/ 5.0</span>
        </div>
        <h3 className="font-display text-xl font-bold leading-tight mb-2">
          <Link to={`/products/${product.slug}`} className="hover:text-[#FFC107] transition-colors">
            {product.name}
          </Link>
        </h3>
        <p className="text-sm text-zinc-400 leading-relaxed flex-1 mb-5">
          {product.short_description}
        </p>
        <div className="flex items-center justify-between gap-3 mt-auto">
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">Price</div>
            <div className="font-display text-2xl font-black text-[#FFC107]">
              {formatGHS(product.price_ghs)}
            </div>
          </div>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={() => addItem(product, 1)}
            className="h-11 px-4 bg-white text-black font-bold uppercase tracking-wider text-xs flex items-center gap-2 hover:bg-[#FFC107] transition-colors"
          >
            <ShoppingCart size={16} weight="bold" /> Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
